// 发票相关接口
import request from '@/utils/request'
const payApiUrl = process.env.VUE_APP_PAY_API

// 获取发票地址
export function getInvoiceApi(params) {
  return request(
    {
      url: payApiUrl + '/v1/invoiceAddress',
      method: 'get',
      params
    },
    {
      needLoading: true
    }
  )
}

// 新增发票地址
export function addInvoiceApi(data) {
  return request(
    {
      url: payApiUrl + '/v1/invoiceAddress',
      method: 'post',
      data
    },
    {
      needLoading: false
    }
  )
}

// 修改发票地址
export function changeInvoiceApi(data) {
  return request(
    {
      url: payApiUrl + '/v1/invoiceAddress',
      method: 'put',
      data
    },
    {
      needLoading: false
    }
  )
}

// 获取个人开票信息
export function getPersonalInvoiceApi() {
  return request({
    url: payApiUrl + '/v1/getInvoiceUserInfo',
    method: 'get'
  })
}

// 修改个人开票信息
export function changePersonalInvoiceApi(data) {
  return request({
    url: payApiUrl + '/v1/modifyInvoiceUserInfo',
    method: 'put',
    data
  })
}

// 获取开票企业合集
export function getInvoiceCompanyApi() {
  return request({
    url: payApiUrl + '/v1/invoiceAddressJoinCompany',
    method: 'get'
  })
}

// 根据发票地址id删除发票地址
export function removeInvoiceApi(invoiceAddressId) {
  return request({
    url: payApiUrl + `/v1/invoiceAddress/${invoiceAddressId}`,
    method: 'delete',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}
